/* eslint-disable */
import { useState, useEffect, useContext, useRef } from "react";
import { usePreference } from "../../../context/usePreference";
import blurPanel from "../../../utils/BlurPanel";
import { getDataObjArray } from "../Sidebar/SideBarUtils";
import { GetArrayDataCollectionList } from "../../../utils/arrayHelperList";
import { MinuteTableRow } from "./MinuteTableRow";
import { MinuteTableRowFirst } from "./MinuteTableRowFirst";
import { MinuteGraphic } from "./MinuteGraphic";
import { ImageWithFallback } from "../Image/ImageWithFallback";
import { SelectTypeGridEnum, DivChartEnum, DivMinuteEnum } from '../../../utils/enums';
import { updateDateWithTime, roundToNearestTenSeconds } from '../../../utils/dateTimeUtils';
import { PracaComposicao as PracaComposicaoList } from "../../../services/PracaComposicaoService";
import { getAccessTokenLocalStorage } from "../../../context/utils";
import { IPraca } from "../../../context/types";
import { PracaContext } from '../../../context/PracaContext';
import moment from 'moment';
import { useTranslation } from "react-i18next";
import { UiContext } from "../../../context/UiContext";


export function MinuteTable({
  audience,
  audienceFirstTable,
  heading,
  handleScroll,
  lastAudience,
  data,
  dataPie,
  onSelectGridMinute,
  selectTypeGrid,
  changeSelectDiv,
  DivMinute,
  DivChart,

}) {

  const [heightPage, setHeightPage] = useState(window.innerHeight);
  const [heightPie, setHeightPie] = useState(90);
  function updateHeight() {
    setHeightPage(window.innerHeight);
    window.innerWidth < 600 ? setHeightPie(70) : setHeightPie(90);
  }
  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (1 + date.getMonth()).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    return year + month + day;
  }
  function formatTime(dateString, minute = 0) {
    const date = new Date(dateString);
    date.setMinutes(date.getMinutes() - minute);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return hours + minutes + seconds;
  }
  const { t: translateText } = useTranslation();
  const { praca } = useContext(PracaContext);

  const getPracaUrlImage = (id: number) => {
    if (praca != null)
      return praca.find(praca => praca.Id === id).UrlImg;

    return null;
  }
  let openSelectGrid = (event) => {
    blurPanel.setBlur(true);
    onSelectGridMinute(true);
  };

  const getClassNameDiv = (DivChart, DivMinute) => {
    return (DivChart === DivChartEnum.Chart || DivChart === DivChartEnum.Image) &&
      (DivMinute === DivMinuteEnum.Minute || DivMinute === DivMinuteEnum.Image)
      ? "divExib"
      : "divExibHide";
  };

  const getClassNameGrid = (selectTypeGrid) => {
    return (selectTypeGrid === SelectTypeGridEnum.Both || selectTypeGrid === SelectTypeGridEnum.Minute || selectTypeGrid === SelectTypeGridEnum.Image || selectTypeGrid === SelectTypeGridEnum.Empty)
      ? "divExib"
      : "divExibHide"
  };

  const changeToImagePage = (headId) => {
    changeSelectDiv("M", DivMinuteEnum.Image);
    setHeadIdSelected(headId);
    heading.selected = headId;
  }

  const getImageUrl = (settingsImage: { url: any; pais: any; praca: any; data: any; hora: any; }, id: any): string => {
    return `${settingsImage.url}?pais=${settingsImage.pais}&praca=${settingsImage.praca}&id=${id}&data=${settingsImage.data}&hora=${settingsImage.hora}`;
  }

  let u = usePreference();

  const { isMobile, hasShortHeightDetail, minuteHeaderWidthAbsolute, minuteHeaderWidth2Absolute, minuteGraphic, mediaComp, updateElementRects, calculateEmissorasColumn } = useContext(UiContext);

  let headerWidth = calculateEmissorasColumn(heading?.enabled);
  const Indice = u.userPreference?.Indice;

  const [headIdSelected, setHeadIdSelected] = useState(undefined);
  let time = moment(u.userPreference.Horario?.substring(0, 19)).subtract(1, 'minutes').subtract(10, 'seconds');
  let roundedTime = roundToNearestTenSeconds(time).format('HH:mm:ss');
  let tableDay = u.userPreference.ChangeAutoUpdate ?
    updateDateWithTime(u.userPreference.Horario, roundedTime) :
    u.userPreference.Horario
    ;
  const [showPracaPanel, setPracaPanel] = useState(false);
  const [iconPraca, setIconPraca] = useState("header-praca-off");
  const [pracaComposicaoList, setPracaComposicaoList] = useState<IPraca[]>([]);
  const [pracaSelected, setPracaSelected] = useState<IPraca | undefined>(undefined);
  const settingsImage = {
    url: getPracaUrlImage(u.userPreference.Praca.Id) != null ? getPracaUrlImage(u.userPreference.Praca.Id) : u.userPreference.Praca.UrlImg,
    pais: u.userPreference.Country.CountryID,
    praca: pracaSelected != null && u.userPreference.Praca.QtdeSubPracas > 0 ? pracaSelected.PracaEquivalente : u.userPreference.Praca.PracaEquivalente,
    data: formatDate(u.userPreference.Data),
    hora: formatTime(tableDay, u.minuteImage ? u.minuteImage : 0)
  };

  const getDivChartHeight = (DivChart: number, isMobile: boolean): number => {

    const baseHeights = [
      document.querySelector("#minuteGraphic") != null ? document.querySelector("#minuteGraphic")!.clientHeight : 0,
      document.querySelector("#DivMedComp") != null ? document.querySelector("#DivMedComp")!.clientHeight : 0,
      0,
      document.querySelector("#minuteGraphic") != null ? document.querySelector("#minuteGraphic")!.clientHeight + 5 : 0,
    ];

    let baseHeight = baseHeights[DivChart] || 0;
    return baseHeight;
  };
  useEffect(() => {
    updateElementRects(document.querySelector('#minuteGraphic'), document.querySelector('#DivMedComp'));
  }, [document.querySelector('#minuteGraphic'), document.querySelector('#DivMedComp')]);

  useEffect(() => {
    const fetchPracaComposicaoList = async () => {
      if (u.userPreference.Praca.QtdeSubPracas > 0) {
        let token = getAccessTokenLocalStorage();
        const response = await PracaComposicaoList(token);
        if (response.status === 200) {
          const updatedData = response.data.map((item: any) => {
            return {
              ...item,
              Desc: item.Desc.replace(/ REAL TIME/g, '').trim()
            };
          });
          setPracaComposicaoList(updatedData);
          if (pracaSelected == undefined)
            setPracaSelected(updatedData[0]);
        }
      } else {
        setPracaComposicaoList([]);
      }
    };

    fetchPracaComposicaoList();

  }, [u.userPreference.Praca]);

  window.addEventListener("resize", updateHeight);
  const handlePraca = () => {
    setPracaPanel(!showPracaPanel);
    if (showPracaPanel)
      setIconPraca("header-praca-off");
    else
      setIconPraca("header-praca-on");
  }
  const handleChangePracaComposicao = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedOption = event.target.selectedOptions[0];
    const pracaEquivalente = pracaComposicaoList.find(praca => praca.PracaEquivalente === parseInt(selectedOption.value));
    setPracaSelected(pracaEquivalente);
    handlePraca();
  };
  const getHeightTableRight = () => {
    let barraSuperiorHeight = document.querySelector(".menu") != null ? document.querySelectorAll(".menu")[0].clientHeight - 1 : 0;
    let barraInfoHeight = document.querySelector(".divDate") != null ? document.querySelectorAll(".divDate")[0].clientHeight - 5 : 0;
    return hasShortHeightDetail ? heightPage : window.innerHeight - getDivChartHeight(DivChart, isMobile) - barraSuperiorHeight - barraInfoHeight;
  }
  const ImageModal = () => {
    return (
      <div style={{ position: 'fixed', boxSizing: 'border-box', height: '100%', overflow: 'hidden', zIndex: 2, left: '50%', marginLeft: '-150px' }}>
        <div style={{ width: '316px', display: 'block', backgroundColor: '#efeff4' }}>
          <header style={{ textAlign: 'center', lineHeight: '35px', position: 'relative', backgroundColor: '#f8f8f8', borderBottom: '1px solid #bfbfc3' }}>
            <h1 style={{ fontSize: '16px', color: '#000', fontFamily: 'Roboto Bold', letterSpacing: '0.5px', padding: '5px', margin: 0 }}>{translateText("secret.subgroups.title")}</h1>
            <button
              onClick={() => handlePraca()}
              style={{ position: 'absolute', top: '5px', left: '5px', color: '#ff412f', fontSize: '15px', textDecoration: 'none', background: 'none', border: 0, padding: 0 }}>
              {translateText("settings.close")}
            </button>
          </header>
          <div>
            <div style={{ backgroundColor: '#fff', width: '100%', color: '#000', paddingLeft: '30px', paddingRight: '30px', paddingBottom: '20px', paddingTop: '10px', boxSizing: 'border-box' }}>
              <div style={{ width: '100%', display: 'inline-block', padding: '10px', boxSizing: 'border-box' }}>
                <label>{translateText("secret.subgroups.subgroup")}</label>
                <select style={{ width: '100%' }} onChange={handleChangePracaComposicao} value={pracaSelected?.PracaEquivalente}>
                  {pracaComposicaoList.map(praca => (
                    <option key={praca.PracaEquivalente} value={praca.PracaEquivalente} data-abrev={praca.Abrev}>
                      {praca.Desc}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const divTableMinuteLeftRef = useRef<HTMLDivElement>(null);
  const divTableMinuteRightRef = useRef<HTMLDivElement>(null);

  const headerFirstRef = useRef<HTMLTableCellElement | null>(null);

  const handleScrollMinute = (e: React.UIEvent<HTMLDivElement>) => {
    if (divTableMinuteLeftRef.current) {
      divTableMinuteLeftRef.current.scrollTop = (e.target as HTMLDivElement).scrollTop;
    }
    if (handleScroll) handleScroll(e);
  };

  return (
    <div>
      {showPracaPanel && (<ImageModal />)}
      <div id="DivGeralExibs">
        <div id="divExibChart" className="divExib">
          <div className={getClassNameDiv(DivChart, DivMinute)} style={{ width: "100%", display: "block" }}>
            <MinuteGraphic
              heading={heading}
              lastAudience={lastAudience}
              data={data}
              dataPie={dataPie}
              heightPie={heightPie}
              Indice={Indice}
              selectTypeGrid={selectTypeGrid}
              divMinute={DivMinute}
              audience={audience}
            />
          </div>
          <div
            id="divExibMinute"
            className={getClassNameGrid(selectTypeGrid)}
            style={{
              display: "inline-flex",
              width: minuteHeaderWidthAbsolute + minuteHeaderWidth2Absolute + "px"
            }}
          >
            <div
              id="divTableMinuteLeft"
              data-testid="divTableMinuteLeft"
              ref={divTableMinuteLeftRef}
              style={{
                width: minuteHeaderWidthAbsolute + "px",
                minWidth: minuteHeaderWidthAbsolute + "px",
                float: "left",
                overflow: "hidden",
                height: getHeightTableRight(),
                paddingBottom: "17px"
              }}
            >
              <table style={{ position: 'sticky', top: '0', width: "100%", height: isMobile ? "70px" : "55px" }}>
                <thead id="header" >
                  {selectTypeGrid == SelectTypeGridEnum.Image && (
                    <tr>
                      <th
                        className="tableHeaderImage"
                        style={{ minWidth: "120px" }}
                      >
                        {u.userPreference.Praca.QtdeSubPracas > 0 && (
                          <button
                            id="dialogToggle"
                            style={{ border: 0, padding: 0, background: 'none', outline: 'none', marginRight: '10px', color: "#fff" }}
                            onClick={() => handlePraca()}
                          >
                            <span style={{ fontSize: '17px' }}>{pracaSelected != null ? pracaSelected.Abrev : ""}</span>
                            <i className={iconPraca}></i>
                          </button>
                        )}

                      </th>
                    </tr>
                  )}
                  <tr>
                    <th
                      id="headerFirst"
                      className="headerFirst"
                      ref={headerFirstRef}
                      style={{
                        minHeight: isMobile ? "70.8px" : "55.91px",
                        height: isMobile ? "70.8px" : "55.91px"
                      }}
                    >
                      <button
                        className="buttonDet"
                        onClick={openSelectGrid}
                      >
                        {!isMobile ? (
                          <img
                            alt="icon_split_desktop"
                            src={require("../../../img/icon_split_desktop.png")}
                          />
                        ) : (
                          <img
                            alt="icon_split_desktop"
                            src={require("../../../img/icon_split_mobile.png")}
                            style={{ height: hasShortHeightDetail ? "20px" : "30px" }}
                          />
                        )}

                      </button>
                    </th>
                  </tr>
                </thead>
              </table>
              <table
                style={{
                  width: "100%",
                }}
              >

                <tbody>
                  {GetArrayDataCollectionList(audienceFirstTable)?.map(
                    (rowContent, rowID) => (
                      <MinuteTableRowFirst
                        rowContent={rowContent.Data}
                        rowID={rowContent.dataID}
                        key={rowContent.dataID}
                      />
                    )
                  )}
                </tbody>
              </table>
            </div>
            <div
              id="divTableMinuteRight"
              data-testid="divTableMinuteRight"
              ref={divTableMinuteRightRef}
              onScroll={handleScrollMinute}
              style={{
                width: minuteHeaderWidth2Absolute + "px",
                overflowX: "scroll",
                overflow: "auto",
                height: getHeightTableRight(),
                float: "left",
                paddingRight: window.innerWidth <= 120 ? '10px' : '0px',
                display: "block",
                marginLeft: "-1px",
              }}
            >
              <table style={{ position: 'sticky', top: '0', width: minuteHeaderWidth2Absolute, tableLayout: "auto", backgroundColor: "black", height: isMobile ? "70px" : "55px" }}>
                <thead style={{ width: "100%" }}>
                  {selectTypeGrid == SelectTypeGridEnum.Image && (
                    <tr>
                      {heading?.enabled?.map((head, headID) => (
                        <th className="tableHeaderImage" key={head.id} style={selectTypeGrid === SelectTypeGridEnum.Image ? { backgroundColor: head.color } : {}}>
                          {head.thumbnails && (
                            <ImageWithFallback
                              key={head.id}
                              title={head.label}
                              src={getImageUrl(settingsImage, head.id)}
                              style={{ width: "100%" }}
                              dataid={head.id}
                              className=''
                              showTitle={false}
                            />
                          )}
                        </th>
                      ))}
                    </tr>
                  )}
                  <tr>
                    {heading?.enabled?.map((head, headID) => (
                      <th
                        className="tableHeader"
                        key={head.id}
                        style={
                          selectTypeGrid === SelectTypeGridEnum.Image ? {
                            backgroundColor: head.color,
                            width: headerWidth + "px",
                          }
                            : {
                              width: headerWidth + "px",
                              height: isMobile ? "70px" : "55px"
                            }
                        }>
                        <button
                          onClick={() => changeToImagePage(headID)}
                          style={{
                            width: headerWidth - 3 + "px",
                            height: "100%",
                            backgroundColor: "transparent",
                            border: "none",
                            padding: 0,
                            margin: 0,
                            outline: "none",
                            color: "#ffffff"
                          }}>
                          <ImageWithFallback
                            key={head.id}
                            title={head.label}
                            src={head.icons.table}
                            style={{
                              width: isMobile ? "30px" : "44px",
                              fontSize: "11px",
                            }}
                            dataid={head.id}
                            className=''
                            showTitle={false}
                          />

                        </button>
                      </th>
                    ))}
                  </tr>
                </thead>
              </table>
              <table
                style={{
                  width: minuteHeaderWidth2Absolute,
                  tableLayout: "fixed",
                }}
              >
                <tbody>
                  {getDataObjArray(audience).map((rowContent, rowID) => (
                    <MinuteTableRow
                      rowContent={rowContent.DataValueArray}
                      rowID={rowID}
                      key={rowContent.ValueId}
                      selectTypeGrid={selectTypeGrid}
                      heading={heading}
                      headSelected={headIdSelected}
                    />
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
